/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LiveBiddingAuctionPartDto } from '../../models/live-bidding-auction-part-dto';

export interface GetMongoDataLiveBiddingAuctionParts$Params {
  take?: number;
  'X-API-Version'?: string;
}

export function getMongoDataLiveBiddingAuctionParts(http: HttpClient, rootUrl: string, params?: GetMongoDataLiveBiddingAuctionParts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LiveBiddingAuctionPartDto>>> {
  const rb = new RequestBuilder(rootUrl, getMongoDataLiveBiddingAuctionParts.PATH, 'get');
  if (params) {
    rb.query('take', params.take, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LiveBiddingAuctionPartDto>>;
    })
  );
}

getMongoDataLiveBiddingAuctionParts.PATH = '/api/mongo-data/live-bidding-auction-parts';
